// Utilidades de plantillas del lado del navegador (misma lógica que services/templates.js)
const VAR_RE = /\{\{\s*(\d+)\s*\}\}/g;

export function countVars(text) {
  const seen = new Set();
  for (const m of String(text || '').matchAll(VAR_RE)) seen.add(Number(m[1]));
  return seen.size;
}

function fill(text, values = []) {
  return String(text || '').replace(VAR_RE, (_, n) => values[Number(n) - 1] || `{{${n}}}`);
}

/** Partes de la plantilla ya con las variables reemplazadas. */
export function renderParts(components, vars = {}) {
  const find = t => (components || []).find(c => String(c.type).toUpperCase() === t);
  const header = find('HEADER');
  const headerFormat = header ? String(header.format || 'TEXT').toUpperCase() : null;
  return {
    headerFormat,
    header: header ? (headerFormat !== 'TEXT' ? `[${headerFormat.toLowerCase()}]` : fill(header.text, vars.header)) : null,
    body: fill(find('BODY')?.text, vars.body),
    footer: find('FOOTER')?.text || null,
    buttons: (find('BUTTONS')?.buttons || []).map(b => b.text),
  };
}

/** Ejemplos guardados en la plantilla, para usarlos como placeholder. */
export function examplesOf(components) {
  const find = t => (components || []).find(c => String(c.type).toUpperCase() === t);
  return {
    header: find('HEADER')?.example?.header_text || [],
    body: find('BODY')?.example?.body_text?.[0] || [],
  };
}

export const STATUS_STYLE = {
  APPROVED: { color: 'var(--success)', label: 'Aprobada' },
  PENDING: { color: 'var(--warning)', label: 'En revisión' },
  IN_APPEAL: { color: 'var(--warning)', label: 'En apelación' },
  REJECTED: { color: 'var(--danger)', label: 'Rechazada' },
  PAUSED: { color: 'var(--text-2)', label: 'Pausada' },
  DISABLED: { color: 'var(--text-3)', label: 'Deshabilitada' },
  DELETED: { color: 'var(--text-3)', label: 'Ya no está en Meta' },
};
